import * as Joi from 'joi';
import { SiblingFormData } from '../../../models';
import { getMasterCodeObjectDropdownSchema } from '../../../utils/JoiUtils';

const siblingSchema = Joi.object<SiblingFormData>({
  dateOfBirth: Joi.string().required().messages({
    'any.required': 'Date of birth is not allowed to be empty',
  }),
  gender: Joi.string().required().messages({
    'any.required': 'Gender is required',
  }),
  level: getMasterCodeObjectDropdownSchema(false, 'Level'),
  name: Joi.string().max(66).required().messages({
    'string.empty': 'Name is not allowed to be empty',
    'string.max': 'Name cannot be exceed more than 66 characters',
    'any.required': 'Name is required',
  }),
});

export default siblingSchema;
